import { AgentDataMetadataDto } from './metadata.dto';

export class AgentDataDto {
  agentType: string;
  metadata: AgentDataMetadataDto[];

  constructor(d?: AgentDataDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
